<template lang='pug'>
  .bf-wrapper
    slot
</template>

<script>
  export default {
    name: 'bf-wrapper.component'
  }
</script>

<style scoped lang='stylus'>
  .bf-wrapper
    margin 0 auto
    max-width 1200px
    padding 0 20px
    box-sizing border-box
    @media( max-width: 1080px )
      padding 0 3.2vw
    @media( max-width: 480px )
      padding 0 3.6vw

  .view .bf-wrapper, .bf-wrapper.view
    padding 20px

  .bf-wrapper.text
    max-width 36em

  .bf-wrapper.max
    // max-width 100%

  .bf-wrapper.max-280
    max-width 280px
  .bf-wrapper.max-480
    max-width 480px
  .bf-wrapper.max-640
    max-width 640px
  .bf-wrapper.max-760
    max-width 760px
  .bf-wrapper.max-800
    max-width 800px
  .bf-wrapper.max-960
    max-width 960px
  .bf-wrapper.max-1080
    max-width 1080px
  .bf-wrapper.max-1280
    max-width 1280px

  .bf-wrapper.rounded
    border-radius 15px
    overflow hidden
  .bf-wrapper.padded
    padding 32px

  .bf-wrapper.thick-sides
    padding 0 48px
</style>
